import { IApproval } from "./IBase";

export const NotificationTypes = [
  "INFO",
  "APPROVAL",
  "REFRACTION_REQUEST",
] as const;
export type INotificationType = (typeof NotificationTypes)[number];

export type CommunicationChannelType = "SMS" | "EMAIL";

export interface INotification {
  uuid: string;
  farm: null;
  createdAt: string;
  message: string;
  approval?: IApproval;
  oldStatus?: string;
  newStatus?: string;
  communicationChannelType: CommunicationChannelType;
  type: INotificationType;
}

export interface INotificationFilters {
  type?: INotificationType;
  dateAfter?: string;
  dateBefore?: string;
}
